import { z } from 'zod'

export const ProtectedDataSchema = z.object({
  is_template_installation_protected: z.boolean(),
  template_id: z.number(),
  template_installation_id: z.number(),
})

export type ProtectedData = z.infer<typeof ProtectedDataSchema>
